import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, Button, Box, Menu, MenuItem, IconButton } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import LoginModal from "./LoginModal";

const Header = ({ isAuthenticated, setIsAuthenticated }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const [loginOpen, setLoginOpen] = useState(false);
  const [username, setUsername] = useState(""); // Store username

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUsername = localStorage.getItem("username"); // Fetch username
    if (token) {
      setUsername(storedUsername || "Utilisateur"); // Default if no username
    }
  }, []);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username"); // Clear username on logout
    setIsAuthenticated(false);
    setUsername(""); // Reset username
    navigate("/");
  };

  return (
    <>
      <AppBar position="fixed" sx={{ bgcolor: "primary.main", p: 2 }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>NUEVO</Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {isAuthenticated ? (
              <>
                <Typography sx={{ mr: 2 }}>{username}</Typography>
                <IconButton onClick={handleMenuClick} color="inherit">
                  <AccountCircleIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  PaperProps={{ style: { minWidth: "150px" } }}
                >
                  <MenuItem onClick={handleClose}>Profile</MenuItem>
                  <MenuItem onClick={handleLogout}>Déconnexion</MenuItem>
                </Menu>
              </>
            ) : (
              <Button color="inherit" onClick={() => setLoginOpen(true)}>
                Connexion
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} setIsAuthenticated={setIsAuthenticated} />
    </>
  );
};

export default Header;
